import { formatCurrency } from '~/lib/CurrencyHelpers';

export const COUPON_TYPE_FIXED = '$';
export const COUPON_TYPE_PERCENT = '%';

export function couponHumanDiscount(coupon) {
    if (coupon?.value?.type === COUPON_TYPE_FIXED) {
        return formatCurrency(coupon?.value?.fixedDiscount);
    } else {
        return `${coupon?.value?.percentDiscount || 0}%`;
    }
}

export function countCodes(codes) {
    return (codes || '').split('\n').filter(c => !!c.trim()).length;
}
